import React from "react"
import {
  Box,
  Container,
  Grid,
  Heading,
  Text,
  Image,
  Flex,
} from "@theme-ui/components"
import RichContentStructuredText from "../richContentStructuredText"
import {
  Accordion as AccordionWrapper,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
  AccordionItemState,
} from "react-accessible-accordion"
import AccordionClosed from "../../images/coesi-accordion-closed.svg"
import AccordionOpened from "../../images/coesi-accordion-open.svg"
import { useColorMode } from "theme-ui"

const SingleAccordion = ({ title, subtitle, body }) => {
  const [colorMode] = useColorMode()

  return (
    <Box mb={[3, 5]}>
      <AccordionWrapper allowZeroExpanded>
        <AccordionItem>
          <AccordionItemState>
            {state => (
              <>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    <Flex
                      sx={{
                        width: "80%",
                        mt: 4,
                        mb: 4,
                        borderRadius: "40px",
                        justifyContent: "space-between",
                        alignItems: "center",
                        cursor: "pointer",
                        backgroundColor: state.expanded ? "light" : "dark",
                        transition: "all 0.2s ease-in-out",
                        border: "1px solid",

                        ".accordion-icon": {
                          img: {
                            filter:
                              colorMode === "dark" ? "null" : "invert(100%)",
                          },
                        },
                        "&:hover": {
                          backgroundColor: state.expanded ? "dark" : "light",

                          borderColor: state.expanded ? "light" : "dark",
                          h3: {
                            color: state.expanded ? "light" : "dark",
                          },
                          ".accordion-icon img": {
                            filter:
                              colorMode === "light" || colorMode === "dark"
                                ? "invert(100%)"
                                : "invert(0)",
                          },
                        },
                      }}
                    >
                      <Heading
                        as="h3"
                        variant="h5"
                        sx={{
                          textTransform: "uppercase",
                          flexBasis: "90%",
                          fontSize: [
                            "18px!important",
                            "16px!important",
                            "16px!important",
                          ],
                          p: [3, 3, 4, 4],
                          fontWeight: "bold",
                          color: state.expanded ? "dark" : "light",
                          mt: [0],
                          mb: [0],
                        }}
                      >
                        {title}
                      </Heading>
                      <Box sx={{ mr: 4 }} className="accordion-icon">
                        {state.expanded ? (
                          <Image src={AccordionOpened} />
                        ) : (
                          <Image src={AccordionClosed} />
                        )}
                      </Box>
                    </Flex>
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <Box sx={{ mt: 3, mb: 4 }}>
                    {subtitle && (
                      <Text
                        sx={{
                          mt: 0,
                          mb: 3,
                          color: "dark",
                          fontSize: "16px",
                        }}
                        dangerouslySetInnerHTML={{ __html: subtitle }}
                      />
                    )}
                    {body && (
                      <Box
                        sx={{
                          color: "dark",
                          p: {
                            color: "dark",
                            fontSize: "16px",
                          },
                        }}
                      >
                        <RichContentStructuredText text={body} />
                      </Box>
                    )}
                  </Box>
                </AccordionItemPanel>
              </>
            )}
          </AccordionItemState>
        </AccordionItem>
      </AccordionWrapper>
    </Box>
  )
}

export default SingleAccordion
